import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrDoctorIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M7.8961 7.84106C10.0779 7.84106 11.7403 6.03973 11.7403 3.92053C11.7403 1.69536 9.97403 0 7.8961 0C5.71429 0 4.05195 1.80132 4.05195 3.92053C3.94805 6.03973 5.71429 7.84106 7.8961 7.84106ZM7.8961 1.48344C9.24675 1.48344 10.2857 2.54305 10.2857 3.92053C10.2857 5.29801 9.24675 6.35762 7.8961 6.35762C6.54545 6.35762 5.50649 5.29801 5.50649 3.92053C5.4026 2.54305 6.54545 1.48344 7.8961 1.48344ZM8 8.68874C12.2597 8.68874 16 11.3377 16 15.1523C16 15.5762 15.6883 15.894 15.2727 15.894C14.8571 15.894 14.5455 15.5762 14.5455 15.1523C14.5455 13.351 13.1948 11.6556 11.1169 10.8079V11.1258C12.4675 11.4437 13.4026 12.6093 13.4026 14.0927V15.2583C13.4026 15.6821 13.0909 16 12.6753 16H11.5325C11.1169 16 10.8052 15.6821 10.8052 15.2583C10.8052 14.8344 11.1169 14.5166 11.5325 14.5166H11.9481V14.0927C11.9481 13.245 11.2208 12.5033 10.3896 12.5033C9.55844 12.5033 8.83117 13.245 8.83117 14.0927V14.5166H9.35065C9.76623 14.5166 10.0779 14.8344 10.0779 15.2583C10.0779 15.6821 9.76623 16 9.35065 16H8.1039C7.68831 16 7.37662 15.6821 7.37662 15.2583V14.0927C7.37662 12.6093 8.31169 11.4437 9.66234 11.1258V10.2781C9.14286 10.1722 8.62338 10.0662 8 10.0662C7.06494 10.0662 6.12987 10.2781 5.4026 10.4901V12.1854C6.02597 12.5033 6.54545 13.245 6.54545 13.9868C6.54545 15.0464 5.71429 15.894 4.67532 15.894C3.63636 15.894 2.80519 15.0464 2.80519 13.9868C2.80519 13.245 3.32468 12.6093 3.94805 12.2914V11.2318C2.38961 12.1854 1.45455 13.6689 1.45455 15.1523C1.45455 15.5762 1.14286 15.894 0.727273 15.894C0.311688 15.894 0 15.5762 0 15.1523C0 11.4437 3.74026 8.68874 8 8.68874ZM4.67532 14.4106C4.88312 14.4106 5.09091 14.3046 5.09091 13.9868C5.09091 13.7748 4.88312 13.5629 4.67532 13.5629C4.46753 13.5629 4.25974 13.7748 4.25974 13.9868C4.25974 14.1987 4.46753 14.4106 4.67532 14.4106Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrDoctorIconComponent;
